(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  class PickupDate extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="date"]');
      this.labelInput = this.querySelector('input[name="attributes[Porch Pickup Date]"]');
      this.error = this.querySelector('.cart__pickup-date-error');
      this.rush = this.querySelector('.cart__pickup-date-rush');
      this.rushDays = parseInt(this.dataset.rushDays, 10) || 0;

      const minDays = parseInt(this.dataset.minDays, 10) || 0;
      const maxDays = parseInt(this.dataset.maxDays, 10) || 60;
      this.availableDays = this.dataset.availableDays.split(',').filter(Boolean).map(Number);
      this.blockedDates = this.dataset.blockedDates.split(',').filter(Boolean);
      this.minDate = this.addDays(new Date(), minDays);
      this.maxDate = this.addDays(new Date(), maxDays);
      this.input.min = this.toIso(this.minDate);
      this.input.max = this.toIso(this.maxDate);

      // Refill the picker from the saved "Friday, October 23, 2026" label
      this.input.value = this.parseLabel(this.labelInput.value);

      // Clear a saved date that is no longer valid (e.g. an old cart)
      if (this.input.value && this.validate(this.input.value)) {
        this.input.value = '';
        this.save('');
      }
      this.updateRush();

      this.input.addEventListener('change', () => {
        const message = this.validate(this.input.value);
        this.showError(message);
        this.save(message ? '' : this.input.value);
        this.updateRush();
      });

      this.input.addEventListener('invalid', (event) => {
        event.preventDefault();
        this.showError(this.validate(this.input.value) || 'Please choose a Porch Pickup Date before checking out.');
        this.input.focus();
      });

      // Capture phase on window so this runs before app scripts (e.g. Easify Product
      // Options) that hijack the checkout button and redirect straight to /checkout
      window.addEventListener('click', (event) => {
        if (!event.target.closest('#checkout, [name="checkout"]')) return;
        const message = this.validate(this.input.value);
        if (message) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.showError(message);
          this.input.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.input.focus({ preventScroll: true });
        }
      }, true);
    }

    addDays(date, days) {
      const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      d.setDate(d.getDate() + days);
      return d;
    }

    toIso(date) {
      const pad = (n) => String(n).padStart(2, '0');
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
    }

    parseLabel(label) {
      const months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
      const match = /([a-z]+)\s+(\d{1,2}),\s*(\d{4})\s*$/i.exec(label || '');
      if (!match) return '';
      const month = months.indexOf(match[1].toLowerCase());
      if (month === -1) return '';
      return this.toIso(new Date(Number(match[3]), month, Number(match[2])));
    }

    parseIso(value) {
      const [y, m, d] = value.split('-').map(Number);
      return new Date(y, m - 1, d);
    }

    validate(value) {
      if (!value) return 'Please choose a Porch Pickup Date before checking out.';
      const date = this.parseIso(value);
      if (isNaN(date)) return 'Please choose a valid date.';
      if (date < this.minDate) return `The earliest available pickup date is ${this.format(this.minDate)}.`;
      if (date > this.maxDate) return `Please choose a date on or before ${this.format(this.maxDate)}.`;
      if (!this.availableDays.includes(date.getDay())) {
        const names = ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays'];
        return `Porch pickup isn't available on ${names[date.getDay()]}. Please choose another day.`;
      }
      if (this.blockedDates.includes(value)) return 'Porch pickup isn\'t available on that date. Please choose another day.';
      return '';
    }

    format(date) {
      return date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
    }

    // Short-notice dates are allowed, but remind customers to add a note
    updateRush() {
      if (!this.rush) return;
      const value = this.input.value;
      const today = this.addDays(new Date(), 0);
      const isRush = value && !this.validate(value) && this.parseIso(value) < this.addDays(today, this.rushDays);
      this.rush.hidden = !isRush;
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = !message;
      this.input.setAttribute('aria-invalid', message ? 'true' : 'false');
    }

    save(iso) {
      const label = iso ? this.format(this.parseIso(iso)) : '';
      this.labelInput.value = label;
      // An empty value removes the old _porch_pickup_iso helper from existing carts
      const body = JSON.stringify({ attributes: { 'Porch Pickup Date': label, '_porch_pickup_iso': '' } });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    }
  }

  customElements.define('pickup-date', PickupDate);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
